import {Statistic} from '@primer/react-brand'
import {renderWithNoMarks} from '../../utils'
import type {TextItem} from '../../../../lib/types/contentful/contentTypes/textItem'
import {SupportGrid} from './SupportGrid'

export function SupportStats({items}: {items: TextItem[]}) {
  return items.map((item, index) => (
    <SupportGrid.Item key={item.sys.id} index={index} total={items.length}>
      <Statistic>
        {item.fields.heading && <Statistic.Heading>{renderWithNoMarks(item.fields.heading)}</Statistic.Heading>}
        {item.fields.description && (
          <Statistic.Description>{renderWithNoMarks(item.fields.description)}</Statistic.Description>
        )}
      </Statistic>
    </SupportGrid.Item>
  ))
}
